import { render } from "./InfoOverlay.vue?vue&type=template&id=2d7c4a6e&scoped=true"
import script from "./InfoOverlay.vue?vue&type=script&lang=js"
export * from "./InfoOverlay.vue?vue&type=script&lang=js"

import "./InfoOverlay.vue?vue&type=style&index=0&id=2d7c4a6e&scoped=true&lang=css"

import exportComponent from "/Users/magsin/Projects/sommarfest2022/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7c4a6e"]])

export default __exports__